/*
  * Confidential and Proprietary.
  * Do not distribute without Bloom Harbor Gifts consent.
  * Copyright Bloom Harbor Gifts 2019. All rights reserved.
  */
import React from 'react';

import {
    TextField,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import {
    bool, func, number, object, string,
} from 'prop-types';
import { useSelector } from 'react-redux';
import CUSTOM_BREAKPOINTS from '../../../../../helpers/customBreakpoints';
import {
    getUserSubmittedProductFilterZipcode,
} from '../../../../../../state/ducks/App/App-Selectors';

const useStyles = makeStyles((theme) => ({
    zipInputRoot: {
        borderBottom: theme.palette.gfMobileInputBorderBottom,
        width: '100%',
        marginBottom: 14,
        '&::before': {
            position: 'absolute',
            zIndex: '998',
            color: theme.palette.white,
            lineHeight: '25px',
            fontSize: theme.palette?.text?.fontSize11 || '11px',
            fontWeight: '300',
            content: '"Enter a valid Zip code"',
            bottom: '-25px',
            left: 0,
            paddingLeft: '7px',
            width: '100%',
            height: '25px',
            backgroundColor: theme.palette.colorAlert,
            transition: 'opacity 0.3s ease-in',
            opacity: 0,
        },
        [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            borderBottom: 'none',
            marginBottom: 0,
        },
        '& input': {
            opacity: '1',
            fontSize: theme.typography?.fontSize || '16px',
            [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabPortrait)]: {
                height: '32px',
                backgroundColor: theme.palette.white,
                padding: '0 12px 0 10px',
                fontSize: theme.palette?.text?.fontSize12 || '12px',
                border: theme.palette.gfTabDesktopInputBorder,
                borderRadius: '3px',
                '&::placeholder': {
                    color: '#666666',
                    opacity: '1',
                },
            },
            [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabLandscape)]: {
                fontSize: theme.palette?.text?.fontSize14 || '14px',
            },
        },
        [theme.breakpoints.down(1024)]: {
            width: '100%',
        },

    },
    paddingRight: {
        '& input': {
            '&:focus': {
                outline: '1px solid',
            },
        },
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            paddingRight: 13,
        },
    },
    addOpacity: {
        '&::before': {
            opacity: 1,
        },
    },
    zipLabelRoot: {
        fontSize: theme.typography?.fontSize || '16px',
        color: theme.palette.gfMobileLabelTextColor || '#212121',
        letterSpacing: '0.42px',
        zIndex: 9,
        [theme.breakpoints.down(325)]: {
            fontSize: theme.palette?.text?.fontSize14 || '14px',
        },
        [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            color: theme.palette.white,
            fontSize: theme.palette?.text?.fontSize12 || '12px',
            fontWeight: 300,
        },
        [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabLandscape)]: {
            fontSize: theme.palette?.text?.fontSize14 || '14px',
        },
        '&:hover': {
            borderBottom: 'none',
        },
        '&$zipLabelFocused': {
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
            [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabPortrait)]: {
                color: theme.palette.white,
            },
        },
    },
    zipLabelWarning: {
        '&::after': {
            position: 'absolute',
            zIndex: '999',
            backgroundColor: theme.palette.colorAlert,
            color: theme.palette.white,
            textAlign: 'center',
            content: '"!"',
            fontSize: theme.palette?.text?.fontSize11 || '11px',
            fontWeight: 'bold',
            lineHeight: '16px',
            right: '-20px',
            width: '15px',
            height: '15px',
            borderRadius: '50%',
            animation: '$fadeZoomIn 0.3s ease-in',
        },
        '&$zipLabelFocused': {
            color: theme.palette.colorAlert,
            [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabPortrait)]: {
                color: theme.palette.white,
            },
        },
    },
    ctZipErrorText: {
        '&::after': {
            position: 'relative',
            marginLeft: '7px',
            zIndex: '999',
            color: theme.palette.colorAlert,
            textAlign: 'center',
            content: '"Invalid ZIP code"',
            fontSize: theme.typography?.fontSize || '16px',
            lineHeight: '16px',
            animation: '$fadeZoomIn 0.3s ease-in',
        },
        '& + div > input, & + div > input:focus, & + div > input:active': {
            boxShadow: `0px 0px 0px 1px ${theme.palette.colorAlert}`,
        },
    },
    zipLabelSuccess: {
        '&::after': {
            position: 'absolute',
            zIndex: '999',
            backgroundColor: theme.palette.colorSuccess,
            color: theme.palette.white,
            textAlign: 'center',
            content: '"✓"',
            fontSize: theme.palette?.text?.fontSize10 || '10px',
            fontWeight: 'bold',
            lineHeight: '15px',
            right: '-20px',
            width: '15px',
            height: '15px',
            borderRadius: '50%',
            animation: '$fadeZoomIn 0.3s ease-in',
        },
    },
    zipLabelFocused: {},
    shrink: {
        [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            transform: 'translate(0, 1.5px) scale(1)',
        },
    },
    inputMarginTop: {
        'label + &': {
            [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabPortrait)]: {
                marginTop: '22px',
            },
        },
    },
    inputMarginTopGift: {
        'label + &': {
            marginTop: '13px',
            [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabPortrait)]: {
                marginTop: '13px',
            },
        },
    },
    ctInputMarginTopGift: {
        'label + &': {
            marginTop: '20px',
        },
    },
    '@keyframes fadeZoomIn': {
        '0%': { opacity: 0, transform: 'scale3d(0.3, 0.3, 0.3)' },
        '100%': { opacity: 1 },
    },
    zipLabelGiftFinderFocused: {
        fontSize: '16px',
    },
    ctInputLabelZipMobile: {
        color: '#595959',
        lineHeight: '16px',
        letterSpacing: '0.42px',
        fontWeight: 'normal',
        fontStyle: 'normal',
    },
    ctSelect: {
        [theme.breakpoints.down(768)]: {
            fontSize: theme.palette?.text?.fontSize18 || '18px',
            marginTop: '20px !important',
            background: '#FFF !important',
            border: '1px solid rgb(0, 0, 0)',
            borderRadius: '4px',
            boxShadow: 'none',
            letterSpacing: 'unset',
            '& input, & select': {
                height: '46px',
                padding: '0 12px 2px 12px',
                fontSize: theme.typography?.fontSize || '16px',
                color: '#000',
                borderRadius: '4px',
                border: '1px solid transparent',
                boxShadow: 'none',
                outline: 0,
                '&:focus, &:active': {
                    borderRadius: '4px',
                    border: '1px solid #262626',
                    boxShadow: 'none',
                    outline: 0,
                },
            },
            '& svg': {
                color: '#222222',
                width: '40px',
                height: '40px',
                top: 'calc(50% - 20px)',
            },
            '&.Mui-focused': {
                background: 'transparent',
            },
        },
    },
}));

const GiftFinderZipCodeField = ({
    zipLabel, zipOrAddressInputPlaceholder, giftFinderBodyTextColor, value, currentInputLength, zipcodeIsValid,
    handleChange, giftFinderCodeTheoryView, giftFinderFieldStyle, onSubmitCheck, isLoadingOrVariableSkip,
}) => {
    const classes = useStyles();
    const userSubmittedZip = useSelector(getUserSubmittedProductFilterZipcode);

    // if zipcode is not valid show invalid zip and circle with '!'
    let zipInputRootAddOpac;
    let zipLabelRootWarning;
    let ctZipLabelRootWarning;

    if (zipcodeIsValid === false && currentInputLength >= 5) {
        zipInputRootAddOpac = `${classes.addOpacity}`; // add opacity 1 to ::before
        zipLabelRootWarning = `${classes.zipLabelWarning}`; // add class to show circle
        ctZipLabelRootWarning = `${classes.ctZipErrorText} ${giftFinderFieldStyle.errorMessage}`;
    }
    // if user clicks submit and is empty or less then 5 show error
    let zipInputRootEmptyZip;
    let ctZipInputRootEmptyZip;
    if (onSubmitCheck === true) {
        zipInputRootEmptyZip = `${classes.addOpacity}`;
        ctZipInputRootEmptyZip = `${classes.ctZipErrorText} ${giftFinderFieldStyle.errorMessage}`;
    }

    // if zipcodeIsValid show success check
    let zipLabelRootSuccess;
    if (zipcodeIsValid === true && currentInputLength >= 5) { zipLabelRootSuccess = `${classes.zipLabelSuccess} ${giftFinderFieldStyle.successMessage}`; ctZipInputRootEmptyZip = ''; }

    // input props styling accoding to giftFinderCodeTheoryView value
    let isRootStyle;
    let inputPropStyle;
    if (giftFinderCodeTheoryView) {
        isRootStyle = `${classes.ctInputLabelZipMobile} ${classes.giftFinderField} ${classes.zipLabelRoot} ${ctZipLabelRootWarning} ${zipLabelRootSuccess} ${ctZipInputRootEmptyZip}`;
        inputPropStyle = `${classes.ctSelect} ${zipInputRootEmptyZip} ${zipInputRootAddOpac} ${classes.ctInputMarginTopGift}`;
    } else {
        isRootStyle = `${classes.zipLabelRoot} ${zipLabelRootWarning} ${zipLabelRootSuccess}`;
        inputPropStyle = `${classes.zipInputRoot}  ${zipInputRootAddOpac} ${classes.inputMarginTop} ${zipInputRootEmptyZip}`;
    }

    return (
        <TextField
            fullWidth
            label={zipLabel}
            placeholder={isLoadingOrVariableSkip ? '' : zipOrAddressInputPlaceholder}
            id="zipcode-native-label-placeholder"
            data-test="hp-zipcode-native-label-placeholder"
            name="zipcode"
            defaultValue={userSubmittedZip}
            className={giftFinderCodeTheoryView ? '' : classes.paddingRight}
            InputProps={{
                inputProps: {
                    'data-element': 'zip_code',
                },
                disableUnderline: true,
                classes: {
                    root: inputPropStyle,
                },

            }}
            InputLabelProps={{
                style: {
                    color: giftFinderBodyTextColor,
                },
                shrink: true,
                classes: {
                    shrink: classes.shrink,
                    root: isRootStyle,
                    focused: giftFinderCodeTheoryView ? classes.zipLabelGiftFinderFocused : classes.zipLabelFocused,
                },
            }}
            onChange={handleChange('zip')}
            value={value}
        />
    );
};
GiftFinderZipCodeField.propTypes = {
    zipLabel: string.isRequired,
    zipOrAddressInputPlaceholder: string,
    giftFinderBodyTextColor: string,
    handleChange: func,
    giftFinderCodeTheoryView: bool,
    giftFinderFieldStyle: object,
    onSubmitCheck: bool,
    isLoadingOrVariableSkip: bool.isRequired,
    value: string.isRequired,
    zipcodeIsValid: bool,
    currentInputLength: number.isRequired,
};

GiftFinderZipCodeField.defaultProps = {
    zipOrAddressInputPlaceholder: '',
    giftFinderBodyTextColor: '',
    handleChange: () => { },
    giftFinderCodeTheoryView: false,
    giftFinderFieldStyle: {},
    onSubmitCheck: false,
    zipcodeIsValid: false,
};
export default GiftFinderZipCodeField;
